import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Breadcrumb from '../components/layout/Breadcrumb';
import Seo from '../components/Seo';
import ProductDesign from '../components/services/ProductDesign';
import OutcomeStats from '../components/services/OutcomeStats';
import ServiceCard from '../components/services/ServiceCard';
import ServiceInsight from '../components/services/serviceinsight';
import ServiceFeature from '../components/services/ServiceFeature';
import ServiceAccordion from '../components/services/ServiceAccordion';

const ServicesPage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Small timeout ensures the DOM nodes have fully rendered first
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [hash]);

  return (
    <>
      <Seo
        title="Our Services | PVS Harness Solution"
        description="Custom wire harness design, prototyping, and assembly services for automotive, electrical, and industrial applications."
        path="/services"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://pvsharness.com/" },
            { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://pvsharness.com/services" }
          ]
        }}
      />

      <Breadcrumb
        heading="Our Services"
        links={[
          { label: "Home", url: "/" },
          { label: "Services" }
        ]}
      />

      <ProductDesign/>
      <OutcomeStats/>
      <ServiceCard/>
      <ServiceInsight/>
      <ServiceFeature/>
      <ServiceAccordion/>
    </>
  );
};


export default ServicesPage;